import { render } from "./CompanyOrder.vue?vue&type=template&id=34e4f5f5&scoped=true"
import script from "./CompanyOrder.vue?vue&type=script&lang=js"
export * from "./CompanyOrder.vue?vue&type=script&lang=js"

import "./CompanyOrder.vue?vue&type=style&index=0&id=34e4f5f5&scoped=true&lang=css"

import exportComponent from "/var/www/html/projects/hetfruit/resources/vueapps/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e4f5f5"]])

export default __exports__